module.exports = __webpack_public_path__ + "img/Prog-final-Inperson-day3exh-v1.b016efa1.svg";